var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-style",attrs:{"type":"button"},on:{"click":function($event){_vm.gotosite()}}},[_vm._v("▶ Watch or Listen Now")])}
var staticRenderFns = []

export { render, staticRenderFns }